module.exports = __webpack_public_path__ + "img/logo6.ea91aea3.png";